export default "__VITE_ASSET__ClUHDOO___"